/**
 * What people read for an EatProtein grade code (the server's HealthScore::GRADES).
 * Old codes (PLATINUM, GOLD, SILVER, BRONZE, RED) still read correctly in older history rows.
 */
export const GRADE_NAMES = {
  EXCELLENT: "Excellent Choice",
  VERY_GOOD: "Very Good Choice",
  GOOD: "Good Choice",
  MODERATE: "Eat in Moderation",
  LIMIT: "Eat Occasionally",
  UNRATED: "Not yet rated",
  PLATINUM: "Excellent Choice",
  GOLD: "Very Good Choice",
  SILVER: "Good Choice",
  BRONZE: "Eat in Moderation",
  RED: "Eat Occasionally",
};

export const gradeName = (code) => GRADE_NAMES[code] ?? code ?? "";
